import { ITEMS_TYPES } from "./constants";
import { routes } from "routes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hideAllMenus } from "store/application/application-action";
import { nFormatter } from "utils/parseNumber";

import "./styles/SearchResultItem.scss";

interface ISearchResultItemProps {
  itemType: string;
  itemData: any;
  setSearchInput: (arg: string) => void;
  setCurrentTag: (arg: string[]) => void;
}

export const SearchResultItem = ({ itemType, itemData, setSearchInput, setCurrentTag }: ISearchResultItemProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClickSearchItem = () => {
    setSearchInput("");

    if (itemType === ITEMS_TYPES.isNicheItem) {
      navigate(routes.niche(itemData.id));
    } else if (itemType === ITEMS_TYPES.isPersonItem) {
      navigate(routes.user(itemData.text.substr(1)));
    } else {
      // @ts-ignore
      setCurrentTag(prev => {
        if (prev.includes(itemData.text)) {
          navigate(routes.multipleTag(prev));
          return prev;
        }

        if (prev.length >= 3) {
          return prev;
        }

        navigate(routes.multipleTag([...prev, itemData.text]));
        return [...prev, itemData.text];
      });

    }
    document?.getElementById("global-search-input")?.blur();
    dispatch(hideAllMenus());
  };

  const renderIcon = () => {
    if (itemType === ITEMS_TYPES.isSavedItem) {
      return <div className="SearchResultItem-ClockIcon" />;
    }

    if (itemType === ITEMS_TYPES.isPersonItem) {
      return itemData.image ? (
        <div className="SearchResultItem-PersonIcon" style={{ backgroundImage: `url(${itemData.image})` }} />
      ) : (
        <div className="SearchResultItem-PersonIcon SearchResultItem-PersonIcon_isEmpty" />
      );
    }

    if (itemType === ITEMS_TYPES.isNicheItem) {
      return itemData.image ? (
        <div className="SearchResultItem-NicheIcon" style={{ backgroundImage: `url(${itemData.image})` }} />
      ) : (
        <div className="SearchResultItem-NicheIcon SearchResultItem-NicheIcon_isEmpty" />
      );
    }
  };

  const renderInfo = () => {
    if (itemType === ITEMS_TYPES.isSavedItem || itemType === ITEMS_TYPES.isPersonItem) {
      return (
        <div className="SearchResultItem-Cnt">
          <h4>
            {itemData.text}
            {itemData?.verified && <span />}
          </h4>
        </div>
      );
    }

    if (itemType === ITEMS_TYPES.isNicheItem) {
      return (
        <div className="SearchResultItem-Cnt">
          <h4>{itemData.text}</h4>
          <p>Niche | {nFormatter(itemData.subscribers)} members</p>
        </div>
      );
    }
  };

  return (
    <li className="SearchResultItem" onClick={handleClickSearchItem}>
      { renderIcon() }
      { renderInfo() }
      <div className="SearchResultItem-Arrow"/>
    </li>
  );
};
